import { Action } from 'redux';
import { ContactField, MergeField } from '@dev/ee-api/ee-api-models';

export interface CustomFieldsInterface {
    isLoadingFields: boolean;
    isLoadedFields: boolean;
    isAddingField: boolean;
    lastAddedFieldName?: string;
    collection: ContactField[];
    selectedFieldName: string;
    newField: ContactField;
    visibleSet: ContactField[];
    allFields?: number;
    recognizedFields?: number;
    currentFieldType?: string;
    nameFieldBackendError?: string;
}

export interface NewFieldInterface {
    name: string;
    type: string;
    length?: number;
}

export interface GetContactFieldsParams {
    search?: string;
    limit?: number;
    offset?: number;
    modifyQueryString?: boolean;
    isUrlUpdateDisabled?: boolean;
}

export interface GetContactFieldsStartAction extends Action {
    type: '@@contactfields/FETCH_START';
    payload: {
        isLoadingFields: boolean;
        search?: string;
        limit?: number;
        offset?: number;
        callBackend?: boolean;
        isUrlUpdateDisabled?: boolean;
    };
}

export interface GetContactFieldsErrorAction extends Action {
    type: '@@contactfields/FETCH_ERROR';
    payload: {
        isLoadingFields: boolean;
        isLoadedFields: boolean;
    };
}

export interface GetContactFieldsSuccessAction extends Action {
    type: '@@contactfields/FETCH_SUCCESS';
    payload: {
        isLoadingFields: boolean;
        isLoadedFields: boolean;
        collection: ContactField[];
    };
}

export interface PutContactFieldStartAction extends Action {
    type: '@@contactfields/CREATE_START';
    payload: {
        lastAddedFieldName?: string;
        currentFieldType: string;
        contactField: ContactField;
        isAddingField: boolean;
        successCallback?: (mergeField: MergeField) => void;
    };
}

export interface PutContactFieldErrorAction extends Action {
    type: '@@contactfields/CREATE_ERROR';
    payload: {
        currentFieldType: string;
        isAddingField: boolean;
        nameFieldBackendError?: string;
    };
}

export interface SetCurrentFieldTypeAction extends Action {
    type: '@@contactfields/SET_CURRENT_FIELD_TYPE';
    payload: {
        currentFieldType: string;
    };
}

export interface PutContactFieldSuccessAction extends Action {
    type: '@@contactfields/CREATE_SUCCESS';
    payload: {
        lastAddedFieldName: string;
        currentFieldType: string;
        isAddingField: boolean;
        collection: ContactField[];
        newField: ContactField;
    };
}

export interface DeleteContactFieldStartAction extends Action {
    type: '@@contactfields/DELETE_START';
    payload: {
        name: string;
    };
}

export interface DeleteContactFieldErrorAction extends Action {
    type: '@@contactfields/DELETE_ERROR';
}

export interface DeleteContactFieldSuccessAction extends Action {
    type: '@@contactfields/DELETE_SUCCESS';
    payload: {
        collection: ContactField[];
        selectedFieldName: string;
    };
}

export interface SetCustomFieldAction extends Action {
    type: '@@contactfields/SET_CUSTOM_FIELD';
    payload: {
        newField: NewFieldInterface;
    };
}

export interface SetCollectionAction extends Action {
    type: '@@contactfields/SET_COLLECTION';
    payload: {
        visibleSet: ContactField[];
    };
}

export interface GetRecognizedFields extends Action {
    type: '@@contactfields/GET_FIELDS';
    payload: {
        allFields;
        recognizedFields;
    };
}
export interface SetRecognizedFields extends Action {
    type: '@@contactfields/SET_FIELDS';
    payload: {
        allFields: number;
        recognizedFields: number;
    };
}

export const customFieldsNameBackendErrorMessageID = [
    "duplicate_field_name",
    "cant_add_reserved_fields"
];
